import { Component, OnInit } from '@angular/core';
import { ModalService } from '../modal.service';
declare var $:any;
/**
 * This class represents the information modal component
 */
@Component({
    selector: 'warn-modal',
    templateUrl: 'warn-modal.component.html',
    standalone: false
})

export class WarnModalComponent implements OnInit {

  translateSrc: string;

  private _confirmBtn: HTMLElement;

  constructor(modalService: ModalService) {
    modalService.warn  = this.warn.bind(this);
  }

  ngOnInit() {
    this._confirmBtn = document.getElementById('warnConfirmBtn');
  }

  warn(msgKey: string): Promise<boolean> {
    this.translateSrc = msgKey;
    let promise = new Promise<boolean>(resolve => {
      this._configureConfirmModal(resolve);
    });
    return promise;
  }

  private _configureConfirmModal(resolve: (x: boolean) => any) {
    let confirmed = (e:any) => resolve(true);
    if(!this._confirmBtn) return confirmed(null);

    this._confirmBtn.onclick = ((e:any) => {
      e.preventDefault();
      $('#warnModal').modal('hide');
      confirmed(e);
    });

    $('#warnModal').modal('show');
    $('#warnModal').on('shown.bs.modal', function() {
      $('#warnConfirmBtn').focus();
    });
  }

}
